// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/images/homePage/signup-auth.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%235A7DA1%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800&family=Teko:wght@600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

*::-webkit-scrollbar-thumb {
  background: var(--theme-border);
  border-radius: 10px;
}

*::-webkit-scrollbar-track {
  background: var(--theme-dark);
}

body {
  font-family: "Rubik", sans-serif;
  background: var(--darkGray);
}

.rounded-16 {
  border-radius: 16px !important;
}

.rounded-10 {
  border-radius: 10px !important;
}

.table.table-default {
  margin-bottom: 0;
}
.table.table-default thead tr {
  background: var(--aquaBlue);
}
.table.table-default thead tr th {
  width: 1%;
  font-weight: 400;
  padding: 16px 10px;
  border: none;
  color: var(--white);
  font-size: 14px;
}
.table.table-default thead tr th:first-child {
  border-radius: 14px 0 0 0;
}
.table.table-default thead tr th:last-child {
  border-radius: 0 14px 0 0;
}
.table.table-default tbody tr td {
  color: var(--white);
  font-weight: 400;
  border: none;
  padding: 14px 10px;
  font-size: 13px;
  width: 5%;
}
@media screen and (min-width: 768px) {
  .table.table-default tbody tr td {
    font-size: 14px;
    font-weight: 600;
  }
}
.table.table-default tbody tr .table-data-success {
  color: var(--green);
}
.table.table-default tbody tr:nth-child(even) {
  background: var(--darkSlate);
}
.table.table-default tbody tr:last-child td:first-child {
  border-radius: 0 0 0 18px;
}
.table.table-default tbody tr:last-child td:last-child {
  border-radius: 0 0 18px 0;
}

.form-control {
  background-color: var(--inputbg);
  border: 2px solid transparent;
  color: var(--white);
  padding: 0.438rem 0.75rem;
  border-radius: 0.625rem;
  height: 3rem;
  font-size: 1rem;
}
.form-control:focus {
  color: var(--white);
  border: 2px solid #016c92;
}

.auth-img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: bottom center;
  height: 100%;
  overflow: hidden;
  border-radius: 0px 15px 15px 0px;
  position: relative;
}

.auth-mob-instructions {
  padding: 1rem 0 0;
}
.auth-mob-instructions p {
  font-size: 0.688rem;
  color: var(--white);
  font-weight: 600;
  line-height: 15px;
  margin: 0;
  text-align: center;
}
.auth-mob-instructions p a {
  color: var(--authTabActiveBorder);
  padding-left: 0.2rem;
}

.auth-instruction-text {
  position: absolute;
  width: 100%;
  bottom: 1rem;
  text-align: center;
  padding: 0 1rem;
}
.auth-instruction-text p {
  font-size: 0.875rem;
  color: var(--white);
  font-weight: 600;
  line-height: 20px;
  margin: 0;
}
.auth-instruction-text p a {
  color: var(--headingLink);
  padding-left: 0.2rem;
}

.progress {
  height: 3px;
  background-color: #353b40;
}

.text-green {
  color: var(--green);
}

.text-red {
  color: var(--red);
}

.modal .modal-content {
  background-color: var(--theme-dark);
  border-radius: 15px;
  color: var(--white);
}
.modal .modal-content .modal-body {
  padding: 1.875rem 1.25rem;
}
@media screen and (max-width: 575.98px) {
  .modal .modal-content .modal-body {
    padding: 1.875rem 1rem;
  }
}
.modal .modal-content .btn-close {
  width: 1.5rem;
  max-width: 1.5rem;
  height: 1.5rem;
  background-color: transparent;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  position: absolute;
  top: 0.375rem;
  right: 0.25rem;
}
.modal .modal-content .btn-close svg {
  width: 0.625rem;
  height: 0.625rem;
}
.modal .modal-content .heading-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  position: relative;
}
.modal .modal-content .heading-wrap .modal-title {
  color: var(--white);
  font-size: 2rem;
  font-weight: 500;
  line-height: 2.75rem;
  text-align: center;
}
.modal .modal-content .body-wrap .body-heading {
  color: var(--white);
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.modal .modal-content .body-wrap .form-group {
  margin-bottom: 1.125rem !important;
}
.modal .modal-content .body-wrap .form-group .form-label {
  color: var(--white);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  margin-bottom: 0.25rem;
}
.modal .modal-content .body-wrap .form-group .form-label.form-label-grey {
  color: var(--white);
  margin-left: 0.5rem;
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  z-index: 6;
  padding: 0.25rem;
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons img {
  width: 1.25rem;
  max-width: 1.25rem;
  max-height: 1.25rem;
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn {
  height: 100%;
  background-color: var(--game-color-400);
  border: 0;
  border-radius: 0.313rem;
  color: var(--game-text-100);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.375rem 0.625rem;
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--game-text-100);
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn svg path {
  fill: var(--game-text-100);
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn:hover, .modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn.active {
  background: var(--secondaryRadialBtnLhover);
  color: var(--black);
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn:hover svg, .modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn.active svg {
  fill: var(--black);
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn:hover svg path, .modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn.active svg path {
  fill: var(--black);
}
.modal .modal-content .body-wrap .form-group .input-group {
  position: relative;
}
.modal .modal-content .body-wrap .form-group .input-group .form-control {
  width: 100%;
  height: 3.25rem;
  background-color: var(--theme-dark);
  border: 1px solid var(--theme-border);
  border-radius: 0.375rem;
  color: var(--game-text-100);
  font-size: 0.875rem;
  font-weight: 700;
  padding: 0.625rem 0.75rem;
  margin: 0;
}
.modal .modal-content .body-wrap .btn-box {
  display: flex;
  flex-direction: column;
  gap: 0.938rem;
  margin-top: 0.313rem;
}
.modal .modal-content .body-wrap .btn-box .btn {
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.125rem;
  padding: 1rem;
}
.modal .modal-content .body-wrap .btn-box .btn-place-bet {
  background: var(--secondaryRadialBtn);
  color: var(--black-700);
}
.modal .modal-content .body-wrap .btn-box .btn-place-bet:hover {
  background: var(--secondaryRadialBtnLhover);
}
.modal .modal-content .body-wrap .btn-box .btn-place-bet-outline {
  background-color: transparent;
  border: 2px solid var(--game-border-300);
  color: var(--game-text-100);
}
.modal .modal-content .body-wrap .btn-box .btn-text {
  background-color: transparent;
  border: 0;
  color: var(--black);
}
.modal .modal-content .body-wrap ol li {
  font-size: 0.875rem;
}
.modal .modal-content .body-wrap ol li:not(:last-child) {
  margin-bottom: 0.125rem;
}
.modal .modal-content .body-wrap ol li.game-rules-text {
  color: var(--game-text-100);
}
.modal .modal-content .body-wrap hr {
  background-color: var(--game-border-100);
  opacity: 1;
  margin: 1rem 0;
}

.form-group {
  position: relative;
}
.form-group .show-password {
  position: absolute;
  right: 10px;
  top: 38px;
  color: var(--authTabBtnText);
  cursor: pointer;
}

.mt-05 {
  margin-top: 0.125rem;
}

.form-label {
  color: var(--white);
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 2px;
}

select.form-control {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position-x: calc(100% - 10px);
  background-position-y: 50%;
}

.game-container {
  max-width: 1545px;
  background-color: var(--containerBg);
  border-radius: 0.625rem;
  margin: 0 auto;
}
.game-container .game-wrapper {
  display: flex;
}
.game-container .game-wrapper .game-sidebar {
  width: 100%;
  max-width: 405px;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .nav.nav-tabs {
  width: 100%;
  background-color: var(--game-color-100);
  border: 0;
  border-radius: 0.5rem;
  gap: 0.313rem;
  padding: 0.375rem;
  margin-bottom: 0.938rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .nav.nav-tabs .nav-item {
  min-height: 2.25rem;
  flex-grow: 1;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .nav.nav-tabs .nav-item .nav-link {
  background-color: transparent;
  color: var(--game-text-100);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  padding: 0.5rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .nav.nav-tabs .nav-item .nav-link:hover {
  color: var(--white);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .nav.nav-tabs .nav-item .nav-link.active {
  background: var(--secondaryRadialBtn);
  color: var(--black-700);
  border: none;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group {
  margin-bottom: 0.625rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .form-label {
  color: var(--white);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  margin-bottom: 0.25rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .form-label.form-label-grey {
  color: var(--white);
  margin-left: 0.5rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  z-index: 6;
  padding: 0.25rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons img {
  width: 1.25rem;
  max-width: 1.25rem;
  max-height: 1.25rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons .input-btn {
  height: 100%;
  background-color: var(--game-color-400);
  border: 0;
  border-radius: 0.313reiconm;
  color: var(--game-text-100);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.188rem 0.375rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons .input-btn svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--game-text-100);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons .input-btn svg path {
  fill: var(--game-text-100);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons .input-btn:hover, .game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons .input-btn.active {
  background: var(--secondaryRadialBtnLhover);
  color: var(--black);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons .input-btn:hover svg, .game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons .input-btn.active svg {
  fill: var(--black);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons .input-btn:hover svg path, .game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .custom-input-group-addons .input-btn.active svg path {
  fill: var(--black);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .input-group {
  position: relative;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .form-group .input-group .form-control {
  width: 100%;
  height: 2.75rem;
  background-color: var(--theme-dark);
  border: 1px solid var(--theme-border);
  border-radius: 0.375rem;
  color: var(--game-text-100);
  font-size: 0.875rem;
  font-weight: 700;
  padding: 0.625rem 0.75rem;
  margin: 0;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .btn-box {
  display: flex;
  flex-direction: column;
  gap: 0.938rem;
  margin-top: 0.313rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .btn-box .btn {
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.125rem;
  padding: 1rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .btn-box .btn-place-bet {
  background: var(--secondaryRadialBtn);
  color: var(--black-700);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .btn-box .btn-place-bet:hover {
  background: var(--secondaryRadialBtnLhover);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .btn-box .btn-place-bet-outline {
  background: var(--grey-700);
  color: var(--game-text-100);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .btn-box .btn-place-bet-outline:hover {
  background: var(--grey-700);
  color: var(--white);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .btn-box .btn-text {
  background-color: transparent;
  border: 0;
  color: var(--white);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .risk-btn-box {
  display: flex;
  gap: 0.375rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .risk-btn-box .risk-btn {
  background-color: var(--game-color-500);
  border: 1px solid var(--game-border-200);
  border-radius: 0.375rem;
  color: var(--game-text-100);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.125rem;
  flex-grow: 1;
  padding: 0.75rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .risk-btn-box .risk-btn:hover {
  color: var(--white);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .risk-btn-box .risk-btn.active {
  background: var(--secondaryRadialBtn);
  color: var(--black-700);
  background-color: var(--game-primary);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .bet-win-loss-box {
  border: 1px solid var(--game-border-100);
  border-radius: 0.375rem;
  padding: 1rem 1.25rem;
  margin-bottom: 0.625rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .bet-win-loss-box hr {
  background-color: var(--game-border-100);
  opacity: 1;
  margin: 0.625rem 0;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .bet-win-loss-box .form-group {
  margin-bottom: 0;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .bet-win-loss-box .form-group .input-group .custom-input-group-addons {
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 0;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .bet-win-loss-box .form-group .input-group .form-control {
  height: unset;
  background-color: transparent;
  border: 0;
  padding: 0;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .higher-lower-btn-box {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin-bottom: 0.625rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .higher-lower-btn-box .higher-lower-btn {
  background-image: linear-gradient(var(--game-color-500), var(--game-color-500)), linear-gradient(180deg, var(--game-border-200), var(--game-color-500) 60%);
  border: 1px solid transparent;
  background-origin: border-box;
  background-clip: content-box, border-box;
  border-radius: 0.375rem;
  padding: 0;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .higher-lower-btn-box .higher-lower-btn .higher-lower-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.375rem;
  padding: 0.625rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .higher-lower-btn-box .higher-lower-btn .higher-lower-inner .text {
  color: var(--white);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.125rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .higher-lower-btn-box .higher-lower-btn .higher-lower-inner .inner-text-box {
  height: 1.5rem;
  background-color: var(--game-color-400);
  border-radius: 0.313rem;
  color: var(--cryptoText);
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.125rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.25rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .higher-lower-btn-box .higher-lower-btn .higher-lower-inner .inner-text-box img {
  width: 1rem;
  height: 1rem;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .higher-lower-btn-box .higher-lower-btn:hover {
  background: var(--game-primary);
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .higher-lower-btn-box .higher-lower-btn:disabled {
  pointer-events: all;
  cursor: not-allowed;
}
.game-container .game-wrapper .game-sidebar .game-sidebar-wrap .higher-lower-btn-box .higher-lower-btn:disabled:hover {
  pointer-events: all;
  cursor: not-allowed;
  background-image: linear-gradient(var(--game-color-500), var(--game-color-500)), linear-gradient(180deg, var(--game-border-200), var(--game-color-500) 60%);
}
.game-container .game-wrapper .game-holder {
  width: 100%;
}
@media screen and (max-width: 991.98px) {
  .game-container {
    max-width: 400px;
  }
  .game-container .game-wrapper {
    flex-direction: column;
  }
  .game-container .game-wrapper .game-sidebar {
    max-width: unset;
    border-top: 2px solid var(--game-border-100);
    border-right: 0;
  }
  .game-container .game-wrapper .game-sidebar .game-sidebar-wrap {
    flex-direction: column-reverse;
  }
  .game-container .game-wrapper .game-sidebar .game-sidebar-wrap .btn-box {
    margin-bottom: 0.938rem;
  }
}
.game-container .custom-range-group .form-range {
  width: 100%;
  height: 4px;
  border-radius: 0.5rem;
  outline: none;
  transition: background 450ms ease-in;
  appearance: none;
  -webkit-appearance: none;
}
.game-container .custom-range-group .form-range::-webkit-slider-runnable-track {
  height: 4px;
  background-color: var(--rangeSliderTrack);
}
.game-container .custom-range-group .form-range::-webkit-slider-thumb {
  width: 18px;
  height: 18px;
  background: var(--white);
  border: 4px solid var(--authTabActiveBorder);
  border-radius: 50%;
  cursor: ew-resize;
  margin-top: -7px;
  appearance: none;
  -webkit-appearance: none;
}
.game-container .game-settings-wrap {
  background-color: var(--black900);
}
.game-container .game-settings-wrap .btn-group .dropup-btn {
  background-color: transparent;
  border: 0;
  position: relative;
}
.game-container .game-settings-wrap .btn-group .dropup-btn:hover svg {
  fill: var(--white);
}
.game-container .game-settings-wrap .btn-group .dropup-btn[aria-expanded=true]::before {
  content: "";
  width: 0px;
  height: 0px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid var(--game-border-100);
  position: absolute;
  top: -11px;
  left: 6px;
}
.game-container .game-settings-wrap .btn-group .dropup-btn[aria-expanded=true] svg {
  fill: var(--game-primary);
}
.game-container .game-settings-wrap .btn-group .dropdown-menu {
  min-width: 150px;
  background: var(--game-color-100);
  border: 2px solid var(--game-border-100);
  border-radius: 0.375rem;
  margin-left: 4px !important;
}
.game-container .game-settings-wrap .btn-group .dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.613rem 0.75rem;
  transition: 0.2s all;
  -webkit-transition: 0.2s all;
}
.game-container .game-settings-wrap .btn-group .dropdown-menu .dropdown-item .icon {
  width: 0.875rem;
  min-width: 0.875rem;
  height: 0.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.game-container .game-settings-wrap .btn-group .dropdown-menu .dropdown-item .icon svg {
  width: 100%;
  height: 100%;
  fill: var(--white);
}
.game-container .game-settings-wrap .btn-group .dropdown-menu .dropdown-item .text {
  color: var(--white);
  font-size: 0.825rem;
}
.game-container .game-settings-wrap .btn-group .dropdown-menu .dropdown-item .custom-range-group {
  display: flex;
  align-items: center;
}
.game-container .game-settings-wrap .btn-group .dropdown-menu .dropdown-item:hover {
  background-color: var(--game-color-200);
}
.game-container .game-settings-wrap .btn-group .dropdown-menu .dropdown-item.active, .game-container .game-settings-wrap .btn-group .dropdown-menu .dropdown-item.active:hover {
  background-color: var(--game-primary);
}
.game-container .game-settings-wrap .btn-group .dropdown-menu span.dropdown-item:hover, .game-container .game-settings-wrap .btn-group .dropdown-menu span.dropdown-item.active, .game-container .game-settings-wrap .btn-group .dropdown-menu span.dropdown-item.active:hover {
  background-color: transparent;
}
.game-container .game-settings-wrap .dragable-live-state .dropdown-menu {
  min-width: 250px;
  background: transparent;
  border: transparent;
}
.game-container .game-settings-wrap .dragable-live-state .dropdown-menu .live-state-dropdown-menu {
  background: var(--game-color-100);
  border: 2px solid var(--game-border-100);
  border-radius: 0.375rem;
}
.game-container .game-settings-wrap .dragable-live-state .dropdown-menu .live-state-dropdown-menu .live-state-head {
  background-color: var(--game-border-100);
  cursor: move;
}
.game-container .game-settings-wrap .dragable-live-state .dropdown-menu .live-state-dropdown-menu .live-state-body {
  font-size: 0.825rem;
}
.game-container .game-settings-wrap .game-foot-logo {
  max-width: 165px;
  width: 100%;
}
.game-container .fairness-modal-button {
  color: var(--themeGreyText);
  cursor: pointer;
}
.game-container .fairness-modal-button::selection {
  background: transparent;
}
.game-container .fairness-modal-button:hover {
  color: var(--white);
}
.game-container .fairness-modal-button:active {
  opacity: 0.6;
}

.custom-tabs-nav .nav {
  gap: 0.75rem;
}
.custom-tabs-nav .nav .nav-item .nav-link {
  background-color: var(--authTabBtn) !important;
  border: 2px solid var(--authTabBtn) !important;
  border-radius: 0.625rem !important;
  color: var(--authTabBtnText) !important;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  line-height: 1.75rem !important;
  padding: 0.375rem 1.625rem !important;
}
.custom-tabs-nav .nav .nav-item .nav-link:hover {
  background-color: var(--authTabBtn) !important;
  border: 2px solid var(--headingLink) !important;
  color: var(--headingLink) !important;
}
.custom-tabs-nav .nav .nav-item .nav-link.active, .custom-tabs-nav .nav .nav-item .nav-link.active:hover {
  background-color: var(--authTabBtn) !important;
  border: 2px solid var(--headingLink) !important;
  color: var(--headingLink) !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAEA;EACE,UAAA;EACA,WAAA;AAAF;;AAGA;EACE,+BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,6BAAA;AAAF;;AAGA;EACE,gCAAA;EACA,2BAAA;AAAF;;AAQA;EACE,8BAAA;AALF;;AAQA;EACE,8BAAA;AALF;;AAcA;EACE,gBAAA;AAXF;AAcI;EACE,2BAAA;AAZN;AAcM;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EAUA,eAAA;AArBR;AAaQ;EACE,yBAAA;AAXV;AAcQ;EACE,yBAAA;AAZV;AAsBM;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AApBR;AAsBQ;EARF;IASI,eAAA;IACA,gBAAA;EAnBR;AACF;AAsBM;EACE,mBAAA;AApBR;AAuBM;EACE,4BAAA;AArBR;AA0BU;EACE,yBAAA;AAxBZ;AA2BU;EACE,yBAAA;AAzBZ;;AAiCA;EACE,gCAAA;EACA,6BAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AA9BF;AAgCE;EACE,mBAAA;EACA,yBAAA;AA9BJ;;AAkFA;EACE,mDAAA;EACA,sBAAA;EACA,kCAAA;EACA,YAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;AA/EF;;AAkFA;EACE,iBAAA;AA/EF;AAiFE;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;AA/EJ;AAiFI;EACE,iCAAA;EACA,oBAAA;AA/EN;;AAoFA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAjFF;AAmFE;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AAjFJ;AAmFI;EACE,yBAAA;EACA,oBAAA;AAjFN;;AAsFA;EACE,WAAA;EACA,yBAAA;AAnFF;;AAsFA;EACE,mBAAA;AAnFF;;AAsFA;EACE,iBAAA;AAnFF;;AAsFA;EACE,mCAAA;EACA,mBAAA;EACA,mBAAA;AAnFF;AAqFE;EACE,yBAAA;AAnFJ;AAqFI;EAHF;IAII,sBAAA;EAlFJ;AACF;AAqFE;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAnFJ;AAqFI;EACE,eAAA;EACA,gBAAA;AAnFN;AAuFE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AArFJ;AAuFI;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AArFN;AA0FI;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAxFN;AA2FI;EACE,kCAAA;AAzFN;AA2FM;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AAzFR;AA2FQ;EACE,mBAAA;EACA,mBAAA;AAzFV;AA6FM;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;AA3FR;AA6FQ;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AA3FV;AA8FQ;EACE,YAAA;EACA,uCAAA;EACA,SAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AA5FV;AA8FU;EACE,cAAA;EACA,eAAA;EACA,0BAAA;AA5FZ;AA8FY;EACE,0BAAA;AA5Fd;AAgGU;EAEE,2CAAA;EACA,mBAAA;AA/FZ;AAiGY;EACE,kBAAA;AA/Fd;AAiGc;EACE,kBAAA;AA/FhB;AAsGM;EACE,kBAAA;AApGR;AAsGQ;EACE,WAAA;EACA,eAAA;EACA,mCAAA;EACA,qCAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;AApGV;AAyGI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,oBAAA;AAvGN;AAyGM;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;AAvGR;AA0GM;EACE,qCAAA;EACA,uBAAA;AAxGR;AAyGQ;EACE,2CAAA;AAvGV;AA2GM;EACE,6BAAA;EACA,wCAAA;EACA,2BAAA;AAzGR;AA4GM;EACE,6BAAA;EACA,SAAA;EACA,mBAAA;AA1GR;AA+GM;EACE,mBAAA;AA7GR;AA+GQ;EACE,uBAAA;AA7GV;AAgHQ;EACE,2BAAA;AA9GV;AAmHI;EACE,wCAAA;EACA,UAAA;EACA,cAAA;AAjHN;;AAsHA;EACE,kBAAA;AAnHF;AAqHE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,4BAAA;EACA,eAAA;AAnHJ;;AAuHA;EACE,oBAAA;AApHF;;AA+HA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AA5HF;;AA+LA;EACE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,wCAAA;EACA,0BAAA;AA5LF;;AAoNA;EACE,iBAAA;EAMA,oCAAA;EACA,uBAAA;EACA,cAAA;AAtNF;AAwNE;EAEE,aAAA;AAvNJ;AAyNI;EACE,WAAA;EACA,gBAAA;AAvNN;AA0NM;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAxNR;AA0NQ;EACE,WAAA;EACA,uCAAA;EACA,SAAA;EACA,qBAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;AAxNV;AA0NU;EACE,mBAAA;EACA,YAAA;AAxNZ;AA0NY;EACE,6BAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAxNd;AA0Nc;EACE,mBAAA;AAxNhB;AA2Nc;EACE,qCAAA;EACA,uBAAA;EACA,YAAA;AAzNhB;AA+NQ;EACE,uBAAA;AA7NV;AA+NU;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AA7NZ;AA+NY;EACE,mBAAA;EACA,mBAAA;AA7Nd;AAiOU;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;AA/NZ;AAiOY;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AA/Nd;AAkOY;EACE,YAAA;EACA,uCAAA;EACA,SAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AAhOd;AAkOc;EACE,cAAA;EACA,eAAA;EACA,0BAAA;AAhOhB;AAkOgB;EACE,0BAAA;AAhOlB;AAoOc;EAEE,2CAAA;EACA,mBAAA;AAnOhB;AAqOgB;EACE,kBAAA;AAnOlB;AAqOkB;EACE,kBAAA;AAnOpB;AA0OU;EACE,kBAAA;AAxOZ;AA0OY;EACE,WAAA;EACA,eAAA;EACA,mCAAA;EACA,qCAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;AAxOd;AA6OQ;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,oBAAA;AA3OV;AA6OU;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;AA3OZ;AA8OU;EACE,qCAAA;EACA,uBAAA;AA5OZ;AA6OY;EACE,2CAAA;AA3Od;AA+OU;EACE,2BAAA;EACA,2BAAA;AA7OZ;AA8OY;EACE,2BAAA;EACA,mBAAA;AA5Od;AAgPU;EACE,6BAAA;EACA,SAAA;EACA,mBAAA;AA9OZ;AAkPQ;EACE,aAAA;EACA,aAAA;AAhPV;AAkPU;EACE,uCAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;AAhPZ;AAkPY;EACE,mBAAA;AAhPd;AAmPY;EACE,qCAAA;EACA,uBAAA;EACA,qCAAA;AAjPd;AAsPQ;EACE,wCAAA;EACA,uBAAA;EACA,qBAAA;EACA,uBAAA;AApPV;AAsPU;EACE,wCAAA;EACA,UAAA;EACA,kBAAA;AApPZ;AAuPU;EACE,gBAAA;AArPZ;AAwPc;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAtPhB;AAyPc;EACE,aAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;AAvPhB;AA6PQ;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;AA3PV;AA6PU;EACE,2JAAA;EAEA,6BAAA;EACA,6BAAA;EACA,wCAAA;EACA,uBAAA;EACA,UAAA;AA5PZ;AA8PY;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AA5Pd;AA8Pc;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AA5PhB;AA+Pc;EACE,cAAA;EACA,uCAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;AA7PhB;AA+PgB;EACE,WAAA;EACA,YAAA;AA7PlB;AAkQY;EACE,+BAAA;AAhQd;AAmQY;EACE,mBAAA;EACA,mBAAA;AAjQd;AAoQY;EACE,mBAAA;EACA,mBAAA;EACA,2JAAA;AAlQd;AAyQI;EACE,WAAA;AAvQN;AA2QE;EA7TF;IA8TI,gBAAA;EAxQF;EA0QE;IACE,sBAAA;EAxQJ;EA0QI;IACE,gBAAA;IACA,4CAAA;IACA,eAAA;EAxQN;EA0QM;IACE,8BAAA;EAxQR;EA0QQ;IACE,uBAAA;EAxQV;AACF;AA+QI;EACE,WAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,wBAAA;AA7QN;AA+QM;EACE,WAAA;EACA,yCAAA;AA7QR;AAgRM;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;AA9QR;AAqRE;EACE,iCAAA;AAnRJ;AAqRM;EACE,6BAAA;EACA,SAAA;EACA,kBAAA;AAnRR;AAsRU;EACE,kBAAA;AApRZ;AAkSU;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;EACA,oCAAA;EACA,6CAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAhSZ;AAmSU;EACE,yBAAA;AAjSZ;AAsSM;EACE,gBAAA;EACA,iCAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;AApSR;AAsSQ;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;AApSV;AAsSU;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AApSZ;AAsSY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AApSd;AAwSU;EACE,mBAAA;EACA,mBAAA;AAtSZ;AAySU;EACE,aAAA;EACA,mBAAA;AAvSZ;AA0SU;EACE,uCAAA;AAxSZ;AA2SU;EAEE,qCAAA;AA1SZ;AAgTU;EAGE,6BAAA;AAhTZ;AAuTM;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AArTR;AAuTQ;EACE,iCAAA;EACA,wCAAA;EACA,uBAAA;AArTV;AAuTU;EACE,wCAAA;EACA,YAAA;AArTZ;AAwTU;EACE,mBAAA;AAtTZ;AA4TI;EACE,gBAAA;EACA,WAAA;AA1TN;AA8TE;EACE,2BAAA;EACA,eAAA;AA5TJ;AA8TI;EACE,uBAAA;AA5TN;AA+TI;EACE,mBAAA;AA7TN;AAgUI;EACE,YAAA;AA9TN;;AAoUE;EACE,YAAA;AAjUJ;AAoUM;EACE,8CAAA;EACA,8CAAA;EACA,kCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,qCAAA;AAlUR;AAoUQ;EACE,8CAAA;EACA,+CAAA;EACA,oCAAA;AAlUV;AAqUQ;EAEE,8CAAA;EACA,+CAAA;EACA,oCAAA;AApUV;;AA2UA;;EAEE,wBAAA;EACA,SAAA;AAxUF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800&family=Teko:wght@600;700&display=swap\");\n\n*::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n*::-webkit-scrollbar-thumb {\n  background: var(--theme-border);\n  border-radius: 10px;\n}\n\n*::-webkit-scrollbar-track {\n  background: var(--theme-dark);\n}\n\nbody {\n  font-family: \"Rubik\", sans-serif;\n  background: var(--darkGray);\n  // overflow-x: hidden;\n}\n\n// #root {\n// overflow-x: hidden;\n// }\n\n.rounded-16 {\n  border-radius: 16px !important;\n}\n\n.rounded-10 {\n  border-radius: 10px !important;\n}\n\n// .btn {\n//   font-size: 1rem;\n//   padding: 4px 15px;\n//   border: none;\n// }\n\n.table.table-default {\n  margin-bottom: 0;\n\n  thead {\n    tr {\n      background: var(--aquaBlue);\n\n      th {\n        width: 1%;\n        font-weight: 400;\n        padding: 16px 10px;\n        border: none;\n        color: var(--white);\n\n        &:first-child {\n          border-radius: 14px 0 0 0;\n        }\n\n        &:last-child {\n          border-radius: 0 14px 0 0;\n        }\n\n        font-size: 14px;\n      }\n    }\n  }\n\n  tbody {\n    tr {\n      td {\n        color: var(--white);\n        font-weight: 400;\n        border: none;\n        padding: 14px 10px;\n        font-size: 13px;\n        width: 5%;\n\n        @media screen and (min-width: 768px) {\n          font-size: 14px;\n          font-weight: 600;\n        }\n      }\n\n      .table-data-success {\n        color: var(--green);\n      }\n\n      &:nth-child(even) {\n        background: var(--darkSlate);\n      }\n\n      &:last-child {\n        td {\n          &:first-child {\n            border-radius: 0 0 0 18px;\n          }\n\n          &:last-child {\n            border-radius: 0 0 18px 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n.form-control {\n  background-color: var(--inputbg);\n  border: 2px solid transparent;\n  color: var(--white);\n  padding: 0.438rem 0.75rem;\n  border-radius: 0.625rem;\n  height: 3rem;\n  font-size: 1rem;\n\n  &:focus {\n    color: var(--white);\n    border: 2px solid #016c92;\n  }\n}\n\n// [type='text'],\n// [type='number'] {\n//   &.currency-btc-icon {\n//     background: url('../public/assets/images/common/currency-btc.png');\n//     background-repeat: no-repeat;\n//     background-size: 20px;\n//     background-position: calc(100% - 8px);\n//     padding-right: 34px;\n//   }\n\n//   &.percentage-icon {\n//     background: url('../public/assets/images/common/percentage.png');\n//     background-repeat: no-repeat;\n//     background-size: 14px;\n//     background-position: calc(100% - 8px);\n//     padding-right: 34px;\n//   }\n// }\n\n// .btn-bet,\n// .mainBtn {\n//   background: var(--green);\n//   color: var(--cinder);\n\n//   &:hover,\n//   &:active {\n//     background: var(--hoverGreen);\n//     color: var(--cinder);\n//   }\n// }\n// .auth-bg{\n//   background: url('../public/assets/images/homePage/auth-bg.png');\n//   background-repeat: no-repeat;\n//   background-size: cover;\n//   min-height: 400px;\n//   min-width: 600px;\n// }\n// .auth-modal-wrap{\n//   min-width: 1148px;\n//   @media screen and (max-width: 991.98px){\n//     min-width: 100%;\n//   }\n//   @media screen and (max-width: 767.98px){\n//     min-width: 100%;\n//     padding: 0 10px;\n//     margin: 0;\n//   }\n// }\n.auth-img {\n  background: url('../public/assets/images/homePage/signup-auth.png');\n  background-size: cover;\n  background-position: bottom center;\n  height: 100%;\n  overflow: hidden;\n  border-radius: 0px 15px 15px 0px;\n  position: relative;\n}\n\n.auth-mob-instructions {\n  padding: 1rem 0 0;\n\n  p {\n    font-size: 0.688rem;\n    color: var(--white);\n    font-weight: 600;\n    line-height: 15px;\n    margin: 0;\n    text-align: center;\n\n    a {\n      color: var(--authTabActiveBorder);\n      padding-left: 0.2rem;\n    }\n  }\n}\n\n.auth-instruction-text {\n  position: absolute;\n  width: 100%;\n  bottom: 1rem;\n  text-align: center;\n  padding: 0 1rem;\n\n  p {\n    font-size: 0.875rem;\n    color: var(--white);\n    font-weight: 600;\n    line-height: 20px;\n    margin: 0;\n\n    a {\n      color: var(--headingLink);\n      padding-left: 0.2rem;\n    }\n  }\n}\n\n.progress {\n  height: 3px;\n  background-color: #353b40;\n}\n\n.text-green {\n  color: var(--green);\n}\n\n.text-red {\n  color: var(--red);\n}\n\n.modal .modal-content {\n  background-color: var(--theme-dark);\n  border-radius: 15px;\n  color: var(--white);\n\n  .modal-body {\n    padding: 1.875rem 1.25rem;\n\n    @media screen and (max-width: 575.98px) {\n      padding: 1.875rem 1rem;\n    }\n  }\n\n  .btn-close {\n    width: 1.5rem;\n    max-width: 1.5rem;\n    height: 1.5rem;\n    background-color: transparent;\n    border: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    position: absolute;\n    top: 0.375rem;\n    right: 0.25rem;\n\n    svg {\n      width: 0.625rem;\n      height: 0.625rem;\n    }\n  }\n\n  .heading-wrap {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 2rem;\n    position: relative;\n\n    .modal-title {\n      color: var(--white);\n      font-size: 2rem;\n      font-weight: 500;\n      line-height: 2.75rem;\n      text-align: center;\n    }\n  }\n\n  .body-wrap {\n    .body-heading {\n      color: var(--white);\n      font-size: 1.125rem;\n      font-weight: 500;\n      margin-bottom: 0.5rem;\n    }\n\n    .form-group {\n      margin-bottom: 1.125rem !important;\n\n      .form-label {\n        color: var(--white);\n        font-size: 0.875rem;\n        font-weight: 500;\n        line-height: 1.25rem;\n        margin-bottom: 0.25rem;\n\n        &.form-label-grey {\n          color: var(--white);\n          margin-left: 0.5rem;\n        }\n      }\n\n      .custom-input-group-addons {\n        display: flex;\n        align-items: center;\n        gap: 0.375rem;\n        z-index: 6;\n        padding: 0.25rem;\n\n        img {\n          width: 1.25rem;\n          max-width: 1.25rem;\n          max-height: 1.25rem;\n        }\n\n        .input-btn {\n          height: 100%;\n          background-color: var(--game-color-400);\n          border: 0;\n          border-radius: 0.313rem;\n          color: var(--game-text-100);\n          font-size: 0.875rem;\n          font-weight: 500;\n          line-height: 1.125rem;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          padding: 0.375rem 0.625rem;\n\n          svg {\n            width: 1.25rem;\n            height: 1.25rem;\n            fill: var(--game-text-100);\n\n            path {\n              fill: var(--game-text-100);\n            }\n          }\n\n          &:hover,\n          &.active {\n            background: var(--secondaryRadialBtnLhover);\n            color: var(--black);\n\n            svg {\n              fill: var(--black);\n\n              path {\n                fill: var(--black);\n              }\n            }\n          }\n        }\n      }\n\n      .input-group {\n        position: relative;\n\n        .form-control {\n          width: 100%;\n          height: 3.25rem;\n          background-color: var(--theme-dark);\n          border: 1px solid var(--theme-border);\n          border-radius: 0.375rem;\n          color: var(--game-text-100);\n          font-size: 0.875rem;\n          font-weight: 700;\n          padding: 0.625rem 0.75rem;\n          margin: 0;\n        }\n      }\n    }\n\n    .btn-box {\n      display: flex;\n      flex-direction: column;\n      gap: 0.938rem;\n      margin-top: 0.313rem;\n\n      .btn {\n        border-radius: 0.375rem;\n        font-size: 0.875rem;\n        font-weight: 500;\n        line-height: 1.125rem;\n        padding: 1rem;\n      }\n\n      .btn-place-bet {\n        background: var(--secondaryRadialBtn);\n        color: var(--black-700);\n        &:hover {\n          background: var(--secondaryRadialBtnLhover);\n        }\n      }\n\n      .btn-place-bet-outline {\n        background-color: transparent;\n        border: 2px solid var(--game-border-300);\n        color: var(--game-text-100);\n      }\n\n      .btn-text {\n        background-color: transparent;\n        border: 0;\n        color: var(--black);\n      }\n    }\n\n    ol {\n      li {\n        font-size: 0.875rem;\n\n        &:not(:last-child) {\n          margin-bottom: 0.125rem;\n        }\n\n        &.game-rules-text {\n          color: var(--game-text-100);\n        }\n      }\n    }\n\n    hr {\n      background-color: var(--game-border-100);\n      opacity: 1;\n      margin: 1rem 0;\n    }\n  }\n}\n\n.form-group {\n  position: relative;\n\n  & .show-password {\n    position: absolute;\n    right: 10px;\n    top: 38px;\n    color: var(--authTabBtnText);\n    cursor: pointer;\n  }\n}\n\n.mt-05 {\n  margin-top: 0.125rem;\n}\n\n// select {\n//   background: url('../public/assets/images/common/arrow-down-white.svg') no-repeat right #ddd;\n//   -webkit-appearance: none;\n//   background-position: calc(100% - 12px);\n//   background-size: 16px;\n//   padding-right: 35px !important;\n// }\n\n.form-label {\n  color: var(--white);\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n// .input-group {\n//   .input-group-text {\n//     background-color: var(--btnBgGrey);\n//     border: 2px solid var(--btnBgGrey);\n\n//     .bet-amount-btn {\n\n//       &.active,\n//       &:hover {\n//         background-color: var(--primaryDark);\n//       }\n//     }\n//   }\n// }\n\n// .text-muted {\n//   color: var(--muted) !important;\n// }\n\n// .bet-amount-btn {\n//   background-color: var(--btnBgGrey);\n//   color: var(--white);\n//   padding: 9px 14px;\n\n//   &:hover {\n//     background-color: var(--btnBgGreyHover);\n//     color: var(--muted);\n//   }\n\n//   &.active {\n//     background-color: var(--primaryDark);\n//     color: var(--muted);\n//   }\n\n//   &.bet-amount-btn-wh-60 {\n//     width: 60px;\n//     height: 60px;\n//   }\n// }\n\n// input[disabled],\n// button[disabled],\n// .nav-item.disabled {\n//   cursor: not-allowed !important;\n//   pointer-events: all !important;\n// }\n\n// .btn.btn-default {\n//   background-color: var(--aquaBlue);\n//   color: var(--white);\n//   border-radius: 0.3rem;\n//   min-height: 44px;\n\n//   &:hover {\n//     background-color: var(--darkAqua);\n//   }\n// }\n\n// .cashout-column {\n//   min-width: 60px;\n//   display: inline-block;\n//   text-align: right;\n// }\n\nselect.form-control {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='14' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%235A7DA1' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position-x: calc(100% - 10px);\n  background-position-y: 50%;\n}\n\n// .border-muted {\n//   border-color: var(--borderMuted) !important;\n// }\n\n// .cursor-pointer {\n//   cursor: pointer;\n// }\n\n// .demo-play-casino {\n//   font-size: 10px;\n//   font-weight: bolder;\n// }\n\n// .overflowHidden {\n//   overflow: hidden;\n// }\n\n// .border-muted {\n//   border-color: var(--minePlachholder) !important;\n// }\n\n.game-container {\n  max-width: 1545px;\n  // background-image: linear-gradient(var(--containerBg), var(--containerBg)),\n  //   linear-gradient(180deg, var(--containerBorder), var(--containerBg) 60%);\n  // border: 2px solid transparent;\n  // background-origin: border-box;\n  // background-clip: content-box, border-box;\n  background-color: var(--containerBg);\n  border-radius: 0.625rem;\n  margin: 0 auto;\n\n  .game-wrapper {\n    // border-bottom: 2px solid var(--game-border-100);\n    display: flex;\n\n    .game-sidebar {\n      width: 100%;\n      max-width: 405px;\n      // border-right: 2px solid var(--game-border-100);\n\n      .game-sidebar-wrap {\n        display: flex;\n        flex-direction: column;\n        padding: 1rem;\n\n        .nav.nav-tabs {\n          width: 100%;\n          background-color: var(--game-color-100);\n          border: 0;\n          border-radius: 0.5rem;\n          gap: 0.313rem;\n          padding: 0.375rem;\n          margin-bottom: 0.938rem;\n\n          .nav-item {\n            min-height: 2.25rem;\n            flex-grow: 1;\n\n            .nav-link {\n              background-color: transparent;\n              color: var(--game-text-100);\n              font-size: 0.875rem;\n              font-weight: 500;\n              line-height: 1.25rem;\n              padding: 0.5rem;\n\n              &:hover {\n                color: var(--white);\n              }\n\n              &.active {\n                background: var(--secondaryRadialBtn);\n                color: var(--black-700);\n                border: none;\n              }\n            }\n          }\n        }\n\n        .form-group {\n          margin-bottom: 0.625rem;\n\n          .form-label {\n            color: var(--white);\n            font-size: 0.875rem;\n            font-weight: 500;\n            line-height: 1.25rem;\n            margin-bottom: 0.25rem;\n\n            &.form-label-grey {\n              color: var(--white);\n              margin-left: 0.5rem;\n            }\n          }\n\n          .custom-input-group-addons {\n            display: flex;\n            align-items: center;\n            gap: 0.375rem;\n            z-index: 6;\n            padding: 0.25rem;\n\n            img {\n              width: 1.25rem;\n              max-width: 1.25rem;\n              max-height: 1.25rem;\n            }\n\n            .input-btn {\n              height: 100%;\n              background-color: var(--game-color-400);\n              border: 0;\n              border-radius: 0.313reiconm;\n              color: var(--game-text-100);\n              font-size: 0.75rem;\n              font-weight: 500;\n              line-height: 1.125rem;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              padding: 0.188rem 0.375rem;\n\n              svg {\n                width: 1.25rem;\n                height: 1.25rem;\n                fill: var(--game-text-100);\n\n                path {\n                  fill: var(--game-text-100);\n                }\n              }\n\n              &:hover,\n              &.active {\n                background: var(--secondaryRadialBtnLhover);\n                color: var(--black);\n\n                svg {\n                  fill: var(--black);\n\n                  path {\n                    fill: var(--black);\n                  }\n                }\n              }\n            }\n          }\n\n          .input-group {\n            position: relative;\n\n            .form-control {\n              width: 100%;\n              height: 2.75rem;\n              background-color: var(--theme-dark);\n              border: 1px solid var(--theme-border);\n              border-radius: 0.375rem;\n              color: var(--game-text-100);\n              font-size: 0.875rem;\n              font-weight: 700;\n              padding: 0.625rem 0.75rem;\n              margin: 0;\n            }\n          }\n        }\n\n        .btn-box {\n          display: flex;\n          flex-direction: column;\n          gap: 0.938rem;\n          margin-top: 0.313rem;\n\n          .btn {\n            border-radius: 0.375rem;\n            font-size: 1rem;\n            font-weight: 500;\n            line-height: 1.125rem;\n            padding: 1rem;\n          }\n\n          .btn-place-bet {\n            background: var(--secondaryRadialBtn);\n            color: var(--black-700);\n            &:hover {\n              background: var(--secondaryRadialBtnLhover);\n            }\n          }\n\n          .btn-place-bet-outline {\n            background: var(--grey-700);\n            color: var(--game-text-100);\n            &:hover {\n              background: var(--grey-700);\n              color: var(--white);\n            }\n          }\n\n          .btn-text {\n            background-color: transparent;\n            border: 0;\n            color: var(--white);\n          }\n        }\n\n        .risk-btn-box {\n          display: flex;\n          gap: 0.375rem;\n\n          .risk-btn {\n            background-color: var(--game-color-500);\n            border: 1px solid var(--game-border-200);\n            border-radius: 0.375rem;\n            color: var(--game-text-100);\n            font-size: 0.875rem;\n            font-weight: 500;\n            line-height: 1.125rem;\n            flex-grow: 1;\n            padding: 0.75rem;\n\n            &:hover {\n              color: var(--white);\n            }\n\n            &.active {\n              background: var(--secondaryRadialBtn);\n              color: var(--black-700);\n              background-color: var(--game-primary);\n            }\n          }\n        }\n\n        .bet-win-loss-box {\n          border: 1px solid var(--game-border-100);\n          border-radius: 0.375rem;\n          padding: 1rem 1.25rem;\n          margin-bottom: 0.625rem;\n\n          hr {\n            background-color: var(--game-border-100);\n            opacity: 1;\n            margin: 0.625rem 0;\n          }\n\n          .form-group {\n            margin-bottom: 0;\n\n            .input-group {\n              .custom-input-group-addons {\n                padding-top: 0;\n                padding-bottom: 0;\n                padding-left: 0;\n              }\n\n              .form-control {\n                height: unset;\n                background-color: transparent;\n                border: 0;\n                padding: 0;\n              }\n            }\n          }\n        }\n\n        .higher-lower-btn-box {\n          display: flex;\n          flex-direction: column;\n          gap: 0.625rem;\n          margin-bottom: 0.625rem;\n\n          .higher-lower-btn {\n            background-image: linear-gradient(var(--game-color-500), var(--game-color-500)),\n              linear-gradient(180deg, var(--game-border-200), var(--game-color-500) 60%);\n            border: 1px solid transparent;\n            background-origin: border-box;\n            background-clip: content-box, border-box;\n            border-radius: 0.375rem;\n            padding: 0;\n\n            .higher-lower-inner {\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n              gap: 1.375rem;\n              padding: 0.625rem;\n\n              .text {\n                color: var(--white);\n                font-size: 0.875rem;\n                font-weight: 500;\n                line-height: 1.125rem;\n              }\n\n              .inner-text-box {\n                height: 1.5rem;\n                background-color: var(--game-color-400);\n                border-radius: 0.313rem;\n                color: var(--cryptoText);\n                font-size: 0.75rem;\n                font-weight: 500;\n                line-height: 1.125rem;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                gap: 0.25rem;\n                padding: 0.125rem 0.25rem;\n\n                img {\n                  width: 1rem;\n                  height: 1rem;\n                }\n              }\n            }\n\n            &:hover {\n              background: var(--game-primary);\n            }\n\n            &:disabled {\n              pointer-events: all;\n              cursor: not-allowed;\n            }\n\n            &:disabled:hover {\n              pointer-events: all;\n              cursor: not-allowed;\n              background-image: linear-gradient(var(--game-color-500), var(--game-color-500)), linear-gradient(180deg, var(--game-border-200), var(--game-color-500) 60%);\n            }\n          }\n        }\n      }\n    }\n\n    .game-holder {\n      width: 100%;\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    max-width: 400px;\n\n    .game-wrapper {\n      flex-direction: column;\n\n      .game-sidebar {\n        max-width: unset;\n        border-top: 2px solid var(--game-border-100);\n        border-right: 0;\n\n        .game-sidebar-wrap {\n          flex-direction: column-reverse;\n\n          .btn-box {\n            margin-bottom: 0.938rem;\n          }\n        }\n      }\n    }\n  }\n\n  .custom-range-group {\n    .form-range {\n      width: 100%;\n      height: 4px;\n      border-radius: 0.5rem;\n      outline: none;\n      transition: background 450ms ease-in;\n      appearance: none;\n      -webkit-appearance: none;\n\n      &::-webkit-slider-runnable-track {\n        height: 4px;\n        background-color: var(--rangeSliderTrack);\n      }\n\n      &::-webkit-slider-thumb {\n        width: 18px;\n        height: 18px;\n        background: var(--white);\n        border: 4px solid var(--authTabActiveBorder);\n        border-radius: 50%;\n        cursor: ew-resize;\n        margin-top: -7px;\n        appearance: none;\n        -webkit-appearance: none;\n      }\n    }\n  }\n\n\n\n  .game-settings-wrap {\n    background-color: var(--black900);\n    .btn-group {\n      .dropup-btn {\n        background-color: transparent;\n        border: 0;\n        position: relative;\n\n        &:hover {\n          svg {\n            fill: var(--white);\n          }\n        }\n        // svg.svg-icon {\n        //   fill: var(--tipAmountText);\n        // }\n        // &[disabled] {\n        //   svg.svg-icon {\n        //     opacity: .5;\n        //     fill: var(--white);\n        //   }\n        // }\n\n        &[aria-expanded=true] {\n          &::before {\n            content: '';\n            width: 0px;\n            height: 0px;\n            border-left: 10px solid transparent;\n            border-right: 10px solid transparent;\n            border-top: 10px solid var(--game-border-100);\n            position: absolute;\n            top: -11px;\n            left: 6px;\n          }\n\n          svg {\n            fill: var(--game-primary);\n          }\n        }\n      }\n\n      .dropdown-menu {\n        min-width: 150px;\n        background: var(--game-color-100);\n        border: 2px solid var(--game-border-100);\n        border-radius: 0.375rem;\n        margin-left: 4px !important;\n\n        .dropdown-item {\n          display: flex;\n          align-items: center;\n          gap: 0.75rem;\n          padding: 0.613rem 0.75rem;\n          transition: 0.2s all;\n          -webkit-transition: 0.2s all;\n\n          .icon {\n            width: 0.875rem;\n            min-width: 0.875rem;\n            height: 0.875rem;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            svg {\n              width: 100%;\n              height: 100%;\n              fill: var(--white);\n            }\n          }\n\n          .text {\n            color: var(--white);\n            font-size: 0.825rem;\n          }\n\n          .custom-range-group {\n            display: flex;\n            align-items: center;\n          }\n\n          &:hover {\n            background-color: var(--game-color-200);\n          }\n\n          &.active,\n          &.active:hover {\n            background-color: var(--game-primary);\n          }\n        }\n\n        span.dropdown-item {\n\n          &:hover,\n          &.active,\n          &.active:hover {\n            background-color: transparent;\n          }\n        }\n      }\n    }\n\n    .dragable-live-state {\n      .dropdown-menu {\n        min-width: 250px;\n        background: transparent;\n        border: transparent;\n\n        .live-state-dropdown-menu {\n          background: var(--game-color-100);\n          border: 2px solid var(--game-border-100);\n          border-radius: 0.375rem;\n\n          .live-state-head {\n            background-color: var(--game-border-100);\n            cursor: move;\n          }\n\n          .live-state-body {\n            font-size: 0.825rem;\n          }\n        }\n      }\n    }\n\n    .game-foot-logo {\n      max-width: 165px;\n      width: 100%;\n    }\n  }\n\n  .fairness-modal-button {\n    color: var(--themeGreyText);\n    cursor: pointer;\n\n    &::selection {\n      background: transparent;\n    }\n\n    &:hover {\n      color: var(--white);\n    }\n\n    &:active {\n      opacity: 0.6;\n    }\n  }\n}\n\n.custom-tabs-nav {\n  .nav {\n    gap: 0.75rem;\n\n    .nav-item {\n      .nav-link {\n        background-color: var(--authTabBtn) !important;\n        border: 2px solid var(--authTabBtn) !important;\n        border-radius: 0.625rem !important;\n        color: var(--authTabBtnText) !important;\n        font-size: 0.875rem !important;\n        font-weight: 600 !important;\n        line-height: 1.75rem !important;\n        padding: 0.375rem 1.625rem !important;\n\n        &:hover {\n          background-color: var(--authTabBtn) !important;\n          border: 2px solid var(--headingLink) !important;\n          color: var(--headingLink) !important;\n        }\n\n        &.active,\n        &.active:hover {\n          background-color: var(--authTabBtn) !important;\n          border: 2px solid var(--headingLink) !important;\n          color: var(--headingLink) !important;\n        }\n      }\n    }\n  }\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
